<div class="curr-question-tags-list">
  <div class="label" *ngIf="label">{{ label }}</div>
  <div class="tags">
    <span class="tag-chip" *ngFor="let t of tags; trackBy: trackById">{{ t.tag }}</span>
  </div>
</div>
